<div #pageLoading class="page-loading active">
  <div class="page-loading-inner">
    <div class="page-spinner"></div>
    <span>Loading...</span>
  </div>
</div>
